export class DistributionModel {
    constructor(
        public id:any,
        public distId: any,
        public distName: string,
        public distType: string,
        public distValue: string,
        public createdDt: Date,
        public createdBy: string,
        public empId: string,
        public empName: string,
        public userId: number,
        public roleName: string,
        public email: string,
        public selected: boolean
    ) { }
}
